export const getInitialFormData = 'getInitialFormData';
export const getFormData = 'getFormData';
export const getFormError = 'getFormError';
export const formHasError = 'formHasError';
export const formFieldValue = 'formFieldValue';
export const formHasChanges = 'formHasChanges';
export const formFieldHasChanges = 'formFieldHasChanges';
export const getChangedFormData = 'getChangedFormData';
